import styled from 'styled-components';

//components
import {InstructionRowDesktop} from 'shared/components/InstructionRow';

export const InstructionRow = styled(InstructionRowDesktop)`
  margin: 0 0 1px;
`;
